import $ from 'jquery';

const MobileMenu = (el) => {
    let $el = $(el);

    const query = window.matchMedia('(min-width: 1024px)');
    initSubmenu(query);
    query.addListener(initSubmenu);

    $el.click(function (e) {
        e.preventDefault();

        $('body').toggleClass('js-state-menu-open');
        $el.toggleClass('js-state-menu-open');

        if($el.data('toggle') !== undefined)
            $($el.data('toggle')).toggleClass('js-state-menu-open');
    });
};

function initSubmenu(query) {
    if (!query.matches) {
        $('.js-toggle-children').on('click', (e) => {
            if (!$(e.target).hasClass('menu__item')) {
                return;
            }

            e.preventDefault();

            const $currentItem = $(e.currentTarget);
            const $ul = $currentItem.find('ul');
            const isExpanded = $ul.is(':visible');
            $currentItem.toggleClass('menu__item--expanded', !isExpanded);
            $currentItem.toggleClass('menu__item--collapsed', isExpanded);
            $ul.slideToggle();
        });
    } else {
        $('.js-toggle-children').off('click');
    }
}

export default MobileMenu;
